import { useCallback } from 'react';
import { useAppDispatch } from 'hooks/redux';
import Analytics from 'modules/Analytics';
import type { EffectTypes } from 'services/Effects';
import type { Offer } from 'lib/LobbyEntities';

type useSlotTileAnalyticsProps = {
  offer: Offer;
  source: EffectTypes.OfferClickedSourceType;
};

const useOfferBannerAnalytics = ({ offer, source }: useSlotTileAnalyticsProps) => {
  const dispatch = useAppDispatch();
  const { type, refName } = offer;

  return useCallback(
    ({ interactionType }) => {
      dispatch(
        Analytics.actions.offerClicked({
          refName,
          type: type || 'SIMPLE',
          source,
          interactionType
        })
      );
    },
    [refName, type, source, dispatch]
  );
};

export default useOfferBannerAnalytics;
